module.exports = __webpack_public_path__ + "static/media/varais-17-copia.1e056508.jpg";